import { useEffect, useRef, useState } from "react";
import QrScanner from "qr-scanner";
import { getDoc, doc } from "firebase/firestore";
import "./QrGuestScanScreen.css";
import { db } from "../../../../firebase/firebase";

import cameraIcon from "../../../../assets/img/icons/qr-camera.ico";
import { GuestInvitationCard } from "./guest-card/GuestInvitationCard";
import { SpinnerOverlay } from "../../../../components/spinner/SpinnerOverlay";
export const QrGuestScanScreen = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const scannerRef = useRef<QrScanner | null>(null);

  const [guestData, setGuestData] = useState<null | {
    name: string;
    table?: number;
    guests?: string[];
    invited?: number;
  }>(null);
  const [scannerReady, setScannerReady] = useState(false);
  const [status, setStatus] = useState<
    "idle" | "scanning" | "searching" | "found" | "error"
  >("idle");
  const lastTokenRef = useRef<string | null>(null);
  const [zoom, setZoom] = useState(1);
  const [maxZoom, setMaxZoom] = useState(1);
  const [resetting, setResetting] = useState(false);

  const startScanner = async () => {
    if (!videoRef.current) return;

    setStatus("scanning");

    const scanner = new QrScanner(
      videoRef.current,
      async (result) => {
        const token = result.data.trim();
        if (token === lastTokenRef.current) return;

        lastTokenRef.current = token;
        setStatus("searching");
        try {
          const docRef = doc(db, "guests", token);
          const snapshot = await getDoc(docRef);

          if (!snapshot.exists()) {
            setStatus("error");
            return;
          }

          const data = snapshot.data();
          setGuestData({
            name: data.name,
            table: data.table || null,
            guests: data.guests || [],
            invited: data.invited,
          });

          setStatus("found");
          // scanner.stop();
        } catch (err) {
          console.error("Error al leer QR:", err);
          setStatus("error");
        }
      },
      {
        returnDetailedScanResult: true,
        highlightScanRegion: true,
        highlightCodeOutline: true,
      }
    );

    scannerRef.current = scanner;
    scanner.start();
    const waitForStream = () =>
      new Promise<void>((resolve) => {
        const check = () => {
          if (videoRef.current?.srcObject) {
            resolve();
          } else {
            setTimeout(check, 50);
          }
        };
        check();
      });

    await waitForStream();
    const stream = videoRef.current.srcObject as MediaStream;
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities() as any;

    if (capabilities.zoom) {
      const min = capabilities.zoom.min ?? 1;
      const max = capabilities.zoom.max ?? 1;
      setMaxZoom(max);
      setZoom(min);
      // @ts-ignore
      await track.applyConstraints({ advanced: [{ zoom: min }] });
    }
  };

  useEffect(() => {
    if (scannerReady) {
      startScanner();
    }

    return () => {
      scannerRef.current?.stop();
    };
  }, [scannerReady]);

  const resetScanner = () => {
    setResetting(true);
    setGuestData(null);
    setStatus("scanning");
    setScannerReady(false);
    lastTokenRef.current = null;

    setTimeout(() => {
      setResetting(false);
      setScannerReady(true);
    }, 150);
  };

  const getStatusMessage = () => {
    switch (status) {
      case "idle":
        return "Presiona para activar la cámara";
      case "scanning":
        return "Escaneando QR...";
      case "searching":
        return "🔍 Buscando invitado...";
      case "found":
        return "✅ Invitado encontrado";
      case "error":
        return "❌ Código inválido o invitado no encontrado";
      default:
        return "";
    }
  };

  const changeZoom = async (newZoom: number) => {
    const track = (
      videoRef.current!.srcObject as MediaStream
    ).getVideoTracks()[0];
    const capabilities = track.getCapabilities() as any;
    if (capabilities.zoom) {
      // Limita entre min y max
      const z = Math.max(
        capabilities.zoom.min,
        Math.min(capabilities.zoom.max, newZoom)
      );
      // @ts-ignore
      await track.applyConstraints({ advanced: [{ zoom: z }] });
      setZoom(z);
    }
  };

  if (resetting) return null;
  return (
    <div
      className="qr-scan-section"
      style={guestData ? { height: "100%" } : { height: "100vh" }}
    >
      {status === "searching" && <SpinnerOverlay />}
      {!scannerReady && (
        <div
          className="qr-scan-placeholder"
          onClick={() => setScannerReady(true)}
        >
          {status !== "found" && (
            <p className="qr-status">{getStatusMessage()}</p>
          )}
          <div className="qr-icon" />
          <p className="qr-scanner-text">Escanear QR</p>
        </div>
      )}

      {/* {!guestData && scannerReady && ( */}
      {scannerReady && (
        <>
          <div className="qr-video-wrapper">
            <video ref={videoRef} className="qr-video" />
            <div className="zoom-controls">
              <button
                onClick={() => changeZoom(zoom - 0.5)}
                disabled={zoom <= 1}
              >
                ➖ Zoom Out
              </button>
              <span>{zoom.toFixed(1)}×</span>
              <button
                onClick={() => changeZoom(zoom + 0.5)}
                disabled={zoom >= maxZoom}
              >
                ➕ Zoom In
              </button>
            </div>
          </div>
        </>
      )}

      {/* {guestData && (
        <div className="qr-guest-info">
          <p className="qr-guest-name">{guestData.name}</p>
          {(guestData.guests ?? []).length > 0 && (
            <ul className="qr-guest-list">
              {guestData?.guests?.map((g, i) => (
                <li key={i}>{g}</li>
              ))}
            </ul>
          )}
          {guestData.table !== undefined && (
            <p className="qr-table">Mesa {guestData.table}</p>
          )}
        </div>
      )} */}

      {guestData && (
        <GuestInvitationCard
          data={{
            name: guestData?.name,
            invited: guestData?.invited,
            guests: guestData?.guests,
            table: guestData?.table!,
          }}
        />
      )}

      {/* {(guestData || status === "error") && (
        <div className="qr-rescan-wrapper" onClick={resetScanner}>
          <img
            src={cameraIcon}
            alt="Escanear otro"
            className="qr-rescan-icon"
          />
        </div>
      )} */}
    </div>
  );
};
